import { Input } from "shared/ui/components/Input";

//FIXME: add typings
const InputField = ({
  field,
  helpers,
  onChanged,
  onBlur,
  onFocus,
  type,
  ...restProps
}: any) => {
  const handleChange = (event: any) => {
    if (type === "localeDe") {
      event.target.value = event.target.value.replace(/[^0-9,]/g, "");
    }

    field.onChange(event);

    if (onChanged) {
      onChanged(field.name, event.target.value);
    }
  };

  const handleBlur = (event: any) => {
    if (type === "localeDe") {
      const value = event.target.value;
      if (value) {
        // Заменяем запятую на точку для парсинга
        const numericValue = parseFloat(value.replace(",", "."));
        if (!isNaN(numericValue)) {
          // Форматируем в немецкий формат
          event.target.value = numericValue.toLocaleString("de-DE", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          });
        }
      }

      field.onChange(event);
    }

    field.onBlur(event);

    if (onBlur) {
      onBlur(field.name, event.target.value);
    }
  };

  const handleFocus = (event: any) => {
    if (type === "localeDe") {
      event.target.value = event.target.value.replace(/[^0-9,]/g, "");
    }

    if (field.onFocus) {
      field.onFocus(event);
    }

    if (onFocus) {
      onFocus(field.name, event.target.value);
    }
  };

  return (
    <Input
      {...restProps}
      type={type}
      name={field.name}
      value={field.value}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
    />
  );
};

export default InputField;
